// extracted by mini-css-extract-plugin
export var bg = "Feature-module--bg--8a9f9";
export var container = "Feature-module--container--9b4a6";
export var media_wrapper = "Feature-module--media_wrapper--e95e4";
export var text_block = "Feature-module--text_block--ac140";